export const goalMetrics = [
    "visit",
    "call",
    "text",
    "email",
    "referrals",
    "careStarts",
];
export const activityGoalMetrics = ["visit", "call", "text", "email"];
export const outcomeGoalMetrics = ["referrals", "careStarts"];
export const goalMetricLabels = {
    visit: "Visits",
    call: "Phone calls",
    text: "Texts (SMS)",
    email: "Emails",
    referrals: "Referrals received",
    careStarts: "Care started",
};
export const goalMetricShortLabels = {
    visit: "Visits",
    call: "Calls",
    text: "Texts",
    email: "Emails",
    referrals: "Referrals",
    careStarts: "Care started",
};
export const zeroTargets = () => ({
    visit: 0,
    call: 0,
    text: 0,
    email: 0,
    referrals: 0,
    careStarts: 0,
});
export const pickTargets = (source) => {
    const out = zeroTargets();
    for (const metric of goalMetrics) {
        out[metric] = source[metric];
    }
    return out;
};
export const goalMetricItemLinkKinds = [
    "placement",
    "homeCare",
    "referenceContact",
    "referenceBusiness",
    "community",
];
//# sourceMappingURL=marketing-goal.js.map